module.exports = __webpack_public_path__ + "img/13.e33dc6df.png";